import Vue from "vue";
import store from "@/store";

const DriverCommentNotification = (socket) => {
    socket.listenEvent('RRHH\\DriverCommentNotification', async (response) => {
        store.dispatch("NotificationStore/A_GET_NOTIFICATIONS");
        const title = app.$i18n.t("Driver Comment");
        const subtitle = app.$i18n.t("Comment");
        const icon = "MessageCircleIcon";
        const data = [
            { icon: "UserIcon", title: response.driver_name, description: response.comment, class:"text-primary" }
        ]
        await Vue.prototype.$MessageAlert({
            title,
            subtitle,
            data,
            icon
        });
    });
}

export { DriverCommentNotification }